"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MintCompleteDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const dto_factory_1 = require("../types/dto-factory");
const gal_reporting_groups_1 = require("../types/gal-reporting-groups");
let MintCompleteDTO = class MintCompleteDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.MintCompleteDTO, [
    gal_reporting_groups_1.GalReportingGroups.game,
    gal_reporting_groups_1.GalReportingGroups.product,
]) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "tokenClaimId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tokenId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "transactionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "chain", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Token claim id from mint response'),
    __metadata("design:type", String)
], MintCompleteDTO.prototype, "tokenClaimId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Total items minted'),
    __metadata("design:type", Number)
], MintCompleteDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Token id, e.g. collection/category/type/addditionalkey'),
    __metadata("design:type", String)
], MintCompleteDTO.prototype, "tokenId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Mint transaction id'),
    __metadata("design:type", String)
], MintCompleteDTO.prototype, "transactionId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('e.g. GalaChain, Ethereum'),
    __metadata("design:type", String)
], MintCompleteDTO.prototype, "chain", void 0);
MintCompleteDTO = __decorate([
    (0, decorators_1.Describe)('Minting completed')
], MintCompleteDTO);
exports.MintCompleteDTO = MintCompleteDTO;
